import templateUrl from './owner-form.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    states: '<',
    locked: '<'
  },
  controller: class OwnerFormComponent {
    constructor() {
      'ngInject';
    }

    hasValidContact(adverseEvent) {
      const validVet = (adverseEvent.VetPerson
        && adverseEvent.VetPerson.FirstName
        && adverseEvent.VetPerson.LastName
        && adverseEvent.VetPerson.OfficePhone);

      return validVet;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/owner-form/owner-form.component.js